import { ServiceBase } from "services/base-service";
import { JobsStatusesResponse } from "./types/jobsStatusesResponse";

export class JobStatusesService extends ServiceBase {
  constructor() {
    super();

    this.baseUrl = `${this.baseUrl}/Job`;
  }

  getJobStatuses = async (abortController?: AbortController): Promise<JobsStatusesResponse[]> => {
    const url = `/jobs-statuses`;
    const response = await this.sendGet(url, abortController);

    return response;
  };
}

const jobStatusesService = new JobStatusesService();

export { jobStatusesService };
